import { useLayoutEffect, useRef, useState } from 'react';
import { Button, Form, Input, Modal, Popover, Typography } from 'antd';
import './GuestRemarksCell.less';

const { Text } = Typography;

export default function GuestRemarksCell({ remarks, onEdit }) {
    const textRef = useRef(null);
    const [overflow, setOverflow] = useState(false);
    const text = remarks ?? '';
    const isEmpty = !text.trim();

    useLayoutEffect(() => {
        const el = textRef.current;
        if (!el) {
            setOverflow(false);
            return;
        }
        const check = () => setOverflow(el.scrollHeight > el.clientHeight + 1);
        check();
        const observer = new ResizeObserver(check);
        observer.observe(el);
        return () => observer.disconnect();
    }, [text]);

    return (
        <div className="guest-remarks-cell">
            {isEmpty ? (
                <Text type="secondary">暂无</Text>
            ) : (
                <div className="guest-remarks-body">
                    <div ref={textRef} className="guest-remarks-text">
                        {text}
                    </div>
                    {overflow ? (
                        <Popover trigger="click" placement="topLeft" content={<div className="guest-remarks-full">{text}</div>}>
                            <span className="guest-remarks-view-all">查看完整备注</span>
                        </Popover>
                    ) : null}
                </div>
            )}
            <Button type="link" size="small" className="guest-remarks-edit" aria-label="编辑嘉宾备注" icon={<i className="bi bi-pencil" aria-hidden="true" />} onClick={onEdit} />
        </div>
    );
}

export function GuestRemarksEditModal({ open, form, saving, onCancel, onOk }) {
    return (
        <Modal title="编辑嘉宾备注" open={open} onCancel={onCancel} onOk={onOk} confirmLoading={saving} okText="保存" cancelText="取消" destroyOnHidden centered>
            <Form form={form} layout="vertical" requiredMark={false}>
                <Form.Item name="remarks" label="嘉宾备注">
                    <Input.TextArea maxLength={1000} showCount autoSize={{ minRows: 4, maxRows: 8 }} placeholder="请输入嘉宾备注" />
                </Form.Item>
            </Form>
        </Modal>
    );
}
